import React from "react";

export default function MSAccess_Mid() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Mid</h1>
      <p>This is the MSAccess_Mid component generated from the SQL JSON.</p>
    </div>
  );
}
